module.exports = __webpack_public_path__ + "img/business-icon3-click.5f274e76.png";